// WireDetails.jsx
import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

import styles from '../Account/AddPaymentInputInfo.module.css';
import {useAuth} from "../../AuthContext";
import {AuthContext} from "../../AuthContext";
import {SwapMainAppContext} from "../../SwapMainAppContext";
import backHoverImg from "../static_files/back arrow hover.svg";
import backImg from "../static_files/back arrow.svg";

function WireDetails({
    onClose,
    onBack,  // <--- new prop
}) {
    const {showNotification} = useContext(SwapMainAppContext);

    const [remitterName, setRemitterName] = useState('');
    const [bankName, setBankName] = useState('');
    const [amountWired, setAmountWired] = useState('');
    const [confirmationNumber, setConfirmationNumber] = useState('');

    const [userEmailAddress, setUserEmailAddress] = useState('');
    const [userWalletAddress, setUserWalletAddress] = useState('');

    const {walletAddress} = useContext(AuthContext);
    const {gatewayUserData} = useAuth();
    const [backButtonIsHover, setBackButtonIsHover] = useState(false);

    useEffect(() => {
        if (gatewayUserData) {
            setUserEmailAddress(gatewayUserData.email);
        }
        if (walletAddress) {
            setUserWalletAddress(walletAddress);
        }
    }, [walletAddress, gatewayUserData]);

    useEffect(() => {
        setUserWalletAddress(localStorage.getItem("walletAddress") || '')
    }, []);

    const handleConfirm = async () => {
        // Check if fields are filled
        if (!remitterName || !bankName || !amountWired || !confirmationNumber) {
            showNotification('warning', "You need to fill in all fields before continuing.");
            return;
        }

        onClose();
        const current_utc_time = new Date().toISOString();
        const payload = {
            wallet_address: userWalletAddress || null,
            remitter_name: remitterName || null,
            bank_name: bankName || null,
            amount_wired: amountWired || null,
            confirmation_number: confirmationNumber || null,
            current_utc_time: current_utc_time
        };

        try {
            const response = await fetch(
                'https://usdi-api-jlukzyz7wa-ew.a.run.app/record_email_uid_mint_requests',
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error('Failed to save. Please try again.');
            }
            showNotification('success', "Your mint request has been processed successfully!");
        } catch (err) {
            showNotification('error', "Failed to save. Please try again.");
        }
    };

    const renderFields = () => {
        return (
            <>
                <label>Name of the Remitter</label>
                <input
                    type="text"
                    value={remitterName}
                    placeholder="Remitter name"
                    onChange={(e) => setRemitterName(e.target.value)}
                />
                <label>Bank name</label>
                <input
                    type="text"
                    value={bankName}
                    placeholder="Enter bank name"
                    onChange={(e) => setBankName(e.target.value)}
                />

                <label>Amount Wired</label>
                <input
                    type="text"
                    value={amountWired}
                    placeholder="Enter Amount Wired"
                    onChange={(e) => setAmountWired(e.target.value)}
                />
                <label>Confirmation/Reference Number</label>
                <input
                    type="text"
                    value={confirmationNumber}
                    placeholder="Enter confirmation/reference number "
                    onChange={(e) => setConfirmationNumber(e.target.value)}
                />
            </>
        );
    };

    return ReactDOM.createPortal(
        <div
            className={styles.modalOverlay}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className={styles.modalContainer}>
                <div className={styles.headerRow}>
                    <img
                        style={{
                            background: 'none',
                            border: 'none',
                            width: "20px",
                            height: "20px",
                            cursor: 'pointer'
                        }}
                        src={backButtonIsHover ? backHoverImg : backImg}
                        onMouseEnter={() => setBackButtonIsHover(true)}
                        onMouseLeave={() => setBackButtonIsHover(false)}
                        onClick={onBack} // <--- new onClick
                        alt="Back"
                    />
                    <h2 className={styles.title}>Wire Details</h2>
                    <div className={styles.closeBtn} onClick={onClose}>
                        &times;
                    </div>
                </div>
                <div className={styles.dividerLine}/>
                {renderFields()}
                <button className={styles.confirmBtn} onClick={handleConfirm}>
                    Confirm
                </button>
            </div>
        </div>,
        document.getElementById('root')
    );
}

export default WireDetails;